// Generated by scripts/generate-branded-icons.ts — do not edit by hand.
export const paths: string[] = [
  'M1.5 5C1.5 3.9 2.4 3 3.5 3H12.5C13.6 3 14.5 3.9 14.5 5V11C14.5 12.1 13.6 13 12.5 13H3.5C2.4 13 1.5 12.1 1.5 11V5Z',
  'M14.5 4.9L9.05 8.37C8.41 8.77 7.59 8.77 6.95 8.37L1.5 4.9',
];
